/*
 * @Date: 2023-10-10 11:11:26
 * @Description: cptpp 映射数据
 */
import { getProvinceMeta } from "./utils.js";
const baseRef = {
  按目的地商品查询: {
    title: "按目的地商品查询",
    timeApi: "getYears7", // 时间获取接口C
    viewsInstance: "goal,monthly", // 对应的组件地址
    needConcat: false,
    tableApi: "taxgetTableData",
    exportTableApi: "exportTaxgetTableData",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    bottomControlList: [
      // 下方控制点

      {
        type: "mainbody",
        label: "目的国(地区)",
        paramName: "partnerIds",
        default: "CN", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtDataGoal",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "原产国(地区)",
        paramName: "reporterIds",
        default: "KR,JP,AU,NZ,VN,MY,GB,US,DE,FR,RU", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtDataGoal",
        className: "w440",
        con: {},
      },
      {
        type: "goods",
        label: "目的国(地区)商品",
        default: "73209090", // 默认进出口
        options: [],
        paramName: "hsIds", //hsids默认值需要加在\views\data\goods\asia\goal\monthly 源文件路径下的defaultCmdCode属性（因为ref覆盖问题导致，目前没找到解决方案）这里的默认值也要写，要不然文本框显示的不对，还有区分目的地和原产地查询的ifGather需要在defaultifGather修改l
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "goalProduction",
        className: "w440",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
    ],
    tableList: [
      {
        label: "原产国(地区)",
        row: "reporter_ch",
        width: "110",
        func: "",
      },
      {
        label: "目的国(地区)",
        row: "partner_ch",
        width: "110",
        func: "",
      },
      {
        label: "目的地商品编码",
        row: "hs_id",
        width: "160",
        func: "",
      },
      {
        label: "目的地商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "普通税率",
        row: "normal_rate",
        width: "110",
        func: "",
      },
      {
        label: "最惠国税率",
        row: "mfn_rate",
        width: "160",
        func: "",
      },
      {
        label: "自由贸易协定税率",
        row: "free_rate",
        width: "160",
        func: "",
      },
      {
        label: "自由贸易协定名称",
        row: "free_name",
        width: "240",
      },
      {
        label: "RCEP协定税率",
        row: "rcep_rate",
        width: "160",
      },
      {
        label: "世界贸易组织税率",
        row: "wto_rate",
        width: "160",
        func: "",
      },
      {
        label: "其他协定税率",
        row: "other_rate",
        width: "160",
        func: "",
      },
      {
        label: "其他协定税率名称",
        row: "other_rate_name",
        width: "160",
        func: "",
      },
      {
        label: "币制",
        row: "currency",
        width: "160",
        func: "",
      },
      {
        label: "原产国代码",
        row: "source_code",
        width: "160",
        func: "",
      },
      {
        label: "目的国代码",
        row: "target_code",
        width: "160",
        func: "",
      },
    ],
  },
  按原产地商品查询: {
    title: "按原产地商品查询",
    timeApi: "getYears7", // 时间获取接口C
    viewsInstance: "sourceArea,monthly", // 对应的组件地址
    needConcat: false,
    tableApi: "taxgetTableData",
    exportTableApi: "exportTaxgetTableData",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    bottomControlList: [
      // 下方控制点
      {
        type: "partner",
        label: "原产国(地区)",
        paramName: "reporterIds",
        default: "KR", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtsourceArea",
        className: "w440",
        con: {},
      },
      {
        type: "mainbody",
        label: "目的国(地区)",
        paramName: "partnerIds",
        default: "CN,JP,AU,NZ,VN,MY,GB,US,DE,FR,RU", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtsourceArea",
        className: "w440",
        con: {},
      },

      {
        type: "goods",
        label: "原产国(地区)商品",
        default: "7320909000", // 默认进出口
        options: [],
        paramName: "hsIds", //hsids默认值需要加在\views\data\goods\asia\goal\monthly 源文件路径下的defaultCmdCode属性（因为ref覆盖问题导致，目前没找到解决方案）这里的默认值也要写，要不然文本框显示的不对，还有区分目的地和原产地查询的ifGather需要在defaultifGather修改
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "sourceAreaProduction",
        className: "w440",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
    ],
    tableList: [
      {
        label: "原产国(地区)",
        row: "reporter_ch",
        width: "110",
        func: "",
      },
      {
        label: "目的国(地区)",
        row: "partner_ch",
        width: "110",
        func: "",
      },
      {
        label: "目的地商品编码",
        row: "hs_id",
        width: "160",
        func: "",
      },
      {
        label: "目的地商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "普通税率",
        row: "normal_rate",
        width: "110",
        func: "",
      },
      {
        label: "最惠国税率",
        row: "mfn_rate",
        width: "160",
        func: "",
      },
      {
        label: "自由贸易协定税率",
        row: "free_rate",
        width: "160",
        func: "",
      },
      {
        label: "自由贸易协定名称",
        row: "free_name",
        width: "240",
      },
      {
        label: "RCEP协定税率",
        row: "rcep_rate",
        width: "160",
      },
      {
        label: "世界贸易组织税率",
        row: "wto_rate",
        width: "160",
        func: "",
      },
      {
        label: "其他协定税率",
        row: "other_rate",
        width: "160",
        func: "",
      },
      {
        label: "其他协定税率名称",
        row: "other_rate_name",
        width: "160",
        func: "",
      },
      {
        label: "币制",
        row: "currency",
        width: "160",
        func: "",
      },
      {
        label: "原产国代码",
        row: "source_code",
        width: "160",
        func: "",
      },
      {
        label: "目的国代码",
        row: "target_code",
        width: "160",
        func: "",
      },
    ],
  },
  世界月度: {
    title: "世界月度",
    timeApi: "getYears", // 时间获取接口C
    viewsInstance: "world,monthly", // 对应的组件地址
    tableApi: "getWorldTradeMonth",
    exportTableApi: "worldTradeMonth",
    productId: [0],
    timeParam: "C", // 调用方法时使用的参数
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["year", "startMonth", "endYear", "endMonth"],
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "rgCode",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "cmdCode",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "WorldProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "rtCode",
        default: "156,392,842", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "ptCode",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData",
        className: "w320",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "dateTime",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "rgDescCh",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "rtNameCh",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "ptNameCh",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "cmdCode",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "cmdDescE",
        width: "160",
        func: "",
      },

      {
        label: "金额",
        row: "tradeValue",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "tradeQuantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qtDesc",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "netWeight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "rgDesc",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "rtCode",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "rtTitle",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "ptCode",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "ptTitle",
        width: "160",
        func: "",
      },
    ],
  },
  世界年度: {
    title: "世界年度",
    timeApi: "getYears", // 时间获取接口C
    timeParam: "C", // 调用方法时使用的参数
    viewsInstance: "world,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear",
    exportTableApi: "worldTradeYear",
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["year", "endYear"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "rgCode",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "cmdCode",
        dimensionParamName: "dimensionType",
        // useStyle: true,
        dimensionOptions: [
          { label: "HS as reported", value: "hs" },
          { label: "HS 92", value: "h0" },
          { label: "HS 96", value: "h1" },
          { label: "HS 02", value: "h2" },
          { label: "HS 07", value: "h3" },
          { label: "HS 12", value: "h4" },
          { label: "HS 17", value: "h5" },
          { label: "HS 22", value: "h6" },
          { label: "SITC as reported", value: "st" },
          { label: "SITC Rev.1", value: "s1" },
          { label: "SITC Rev.2", value: "s2" },
          { label: "SITC Rev.3", value: "s3" },
          { label: "SITC Rev.4", value: "s4" },
          { label: "BEC", value: "bec" },
        ],
        components: "Goods",
        componentType: "WorldProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "rtCode",
        default: "156,276,392,826,842,36,124,251,643,699,702", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "ptCode",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "yr",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "rgDescCh",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "rtNameCh",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "ptNameCh",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "cmdCode",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "cmdDescE",
        width: "160",
        func: "",
      },

      {
        label: "金额",
        row: "tradeValue",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "tradeQuantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qtDesc",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "netWeight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "rgDesc",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "rtCode",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "rtTitle",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "ptCode",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "ptTitle",
        width: "160",
        func: "",
      },
    ],
  },
  欧盟月度: {
    title: "欧盟月度",
    timeApi: "getYears24", // 时间获取接口C
    viewsInstance: "EU,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear24",
    exportTableApi: "worldTradeYear24",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "欧元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "EUProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "097,040,276", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData24",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData24",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(100kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
      // {
      //   label: "商品起始时间",
      //   row: "start",
      //   width: "120",
      //   func: "",
      // },
      // {
      //   label: "商品结束时间",
      //   row: "end",
      //   width: "120",
      //   func: "",
      // },
    ],
  },
  欧盟年度: {
    title: "欧盟年度",
    timeApi: "getYears24", // 时间获取接口C
    viewsInstance: "EU,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear24",
    exportTableApi: "worldTradeYear24",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "欧元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "EUProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default:
          "097,040,056,100,196,203,276,208,233,724,246,250,826,300,191,348,372,380,440,442,428,470,528,616,620,642,752,705,703", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData24",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData24",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(100kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
      // {
      //   label: "商品起始时间",
      //   row: "start",
      //   width: "120",
      //   func: "",
      // },
      // {
      //   label: "商品结束时间",
      //   row: "end",
      //   width: "120",
      //   func: "",
      // },
    ],
  },
  东盟季度: {
    title: "东盟季度",
    timeApi: "getYears2", // 时间获取接口C
    viewsInstance: "asean,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear2",
    exportTableApi: "worldTradeYear2",
    timeParam: "Q", // 调用方法时使用的参数
    productId: [0],
    needConcat: true,
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Quarter",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        useStyle: true,
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "aseanProduction",
        con: {},
      },
      {
        type: "mainbody",

        label: "主体",
        paramName: "reporterIds",
        default: "975,096,116,360,418,458,104,608,702,764,704", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData2",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData2",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "140",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "140",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "140",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  东盟年度: {
    title: "东盟年度",
    timeApi: "getYears2", // 时间获取接口C
    viewsInstance: "asean,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear2",
    exportTableApi: "worldTradeYear2",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "aseanProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "975,096,116,360,418,458,104,608,702,764,704", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData2",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData2",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "140",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "140",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "140",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  日本月度: {
    title: "日本月度",
    timeApi: "getYears6", // 时间获取接口C
    viewsInstance: "japan,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear6",
    exportTableApi: "worldTradeYear6",
    timeParam: "M", // 调用方法时使用的参数
    needConcat: true, // 是否需要拼接year和month的传参
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "千日元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        useStyle: true,
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "japanProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "392,392100", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "japanProduction2",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData6",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第一数量",
        row: "quantity1",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第一计量单位",
        row: "qty_unit1",
        width: "110",
        func: "",
      },
      {
        label: "第二数量",
        row: "quantity2",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第二计量单位",
        row: "qty_unit2",
        width: "110",
        func: "",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  日本年度: {
    title: "日本年度",
    timeApi: "getYears6", // 时间获取接口C
    viewsInstance: "japan,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear6",
    exportTableApi: "worldTradeYear6",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "千日元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "japanProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default:
          "392,392100,392200,392300,392400,392500,392600,392700,392800,392900", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "japanProduction2",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData6",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第一数量",
        row: "quantity1",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第一计量单位",
        row: "qty_unit1",
        width: "110",
        func: "",
      },
      {
        label: "第二数量",
        row: "quantity2",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第二计量单位",
        row: "qty_unit2",
        width: "110",
        func: "",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  马来西亚月度: {
    title: "马来西亚月度",
    timeApi: "getYears8", // 时间获取接口C
    viewsInstance: "malaysia,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear8",
    exportTableApi: "worldTradeYear8",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
          {
            label: "本地出口",
            value: "5",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "马来西亚林吉特",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "malaysiaProduction",
        useStyle: true,
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "458", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData8",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData8",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  马来西亚年度: {
    title: "马来西亚年度",
    timeApi: "getYears8", // 时间获取接口C
    viewsInstance: "malaysia,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear8",
    exportTableApi: "worldTradeYear8",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
          {
            label: "本地出口",
            value: "5",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "马来西亚林吉特",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        // useStyle: true,
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "malaysiaProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "458", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData8",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData8",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  加拿大本地出口月度: {
    title: "加拿大本地出口月度",
    timeApi: "getYears12", // 时间获取接口C
    viewsInstance: "jnd,monthlyjc", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear12",
    exportTableApi: "worldTradeYear12",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "5", // 默认进出口
        options: [
          {
            label: "本地出口",
            value: "5",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        useStyle: true,
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "jndbcProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "124", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData12bc",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData12bc",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  加拿大进口月度: {
    title: "加拿大进口月度",
    timeApi: "getYears12", // 时间获取接口C
    viewsInstance: "jnd,monthlyj", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear12",
    exportTableApi: "worldTradeYear12",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "2", // 默认进出口
        options: [
          {
            label: "进口",
            value: "2",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        useStyle: true,
        componentType: "jndjProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "124", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData12j",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData12j",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  加拿大总出口月度: {
    title: "加拿大总出口月度",
    timeApi: "getYears12", // 时间获取接口C
    viewsInstance: "jnd,monthlyc", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear12",
    exportTableApi: "worldTradeYear12",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "6", // 默认进出口
        options: [
          {
            label: "总出口",
            value: "6",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        useStyle: true,
        componentType: "jndzcProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "124", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData12zc",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData12zc",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  智利月度: {
    title: "智利月度",
    timeApi: "getYears10", // 时间获取接口C
    viewsInstance: "zhili,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear10",
    exportTableApi: "worldTradeYear10",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        useStyle: true,
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "zhiliProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "152", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData10",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData10",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  智利年度: {
    title: "智利年度",
    timeApi: "getYears10", // 时间获取接口C
    viewsInstance: "zhili,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear10",
    exportTableApi: "worldTradeYear10",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "zhiliProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "152", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData10",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData10",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  秘鲁月度: {
    title: "秘鲁月度",
    timeApi: "getYears9", // 时间获取接口C
    viewsInstance: "bilu,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear9",
    exportTableApi: "worldTradeYear9",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "1", // 默认进出口
        options: [
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "biluProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "604", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData9",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData9",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  秘鲁年度: {
    title: "秘鲁年度",
    timeApi: "getYears9", // 时间获取接口C
    viewsInstance: "bilu,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear9",
    exportTableApi: "worldTradeYear9",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "1", // 默认进出口
        options: [
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "biluProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "604", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData9",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData9",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  新西兰月度: {
    title: "新西兰月度",
    timeApi: "getYears11", // 时间获取接口C
    viewsInstance: "xxl,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear11",
    needConcat: true,
    exportTableApi: "worldTradeYear11",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        className: "w350",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "新西兰元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "xxlProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "554", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData11",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData11",
        className: "w350",
        con: {},
      },
      {
        type: "port",
        label: "港口",
        paramName: "portIds",
        default: "NZL000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "xxlport",
        className: "w350",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "160",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "160",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "160",
      },
      {
        label: "港口中文名称",
        row: "port_name_cn",
        width: "160",
        func: "160",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "160",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴名称",
        row: "port_id",
        width: "160",
        func: "",
      },
      {
        label: "港口编码",
        row: "port_id",
        width: "160",
        func: "",
      },
      {
        label: "港口英文名称",
        row: "port_name_en",
        width: "160",
        func: "",
      },
    ],
  },
  新西兰年度: {
    title: "新西兰年度",
    timeApi: "getYears11", // 时间获取接口C
    viewsInstance: "xxl,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear11",
    exportTableApi: "worldTradeYear11",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        className: "w350",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "新西兰元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "xxlProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "554", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData11",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData11",
        className: "w350",
        con: {},
      },
      {
        type: "port",
        label: "港口",
        paramName: "portIds",
        default: "NZL000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "xxlport",
        className: "w350",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "港口中文名称",
        row: "port_name_cn",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
      {
        label: "港口编码",
        row: "port_id",
        width: "160",
        func: "",
      },
      {
        label: "港口英文名称",
        row: "port_name_en",
        width: "160",
        func: "",
      },
    ],
  },
  // ===== 巴西 ===== （2026-07-13 新增；现使用阿根廷现有控件作占位，step 2 替换为 brazilProduction/TransportSelect 等）
  巴西月度: {
    title: "巴西月度",
    viewsInstance: "brazil,monthly",
    productId: [0],
    timeApi: "getBrazilTimeData",
    timeParam: "M",
    tableApi: "getBrazilTableData",
    exportTableApi: "brazilTableDownload",
    needConcat: true,
    showOnlyOneChild: true,
    topControlList: [
      {
        type: "time",
        label: "时间",
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true,
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0",
        options: [
          { label: "进出口", value: "0" },
          { label: "进口", value: "2" },
          { label: "出口", value: "1" },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [{ label: "美元", value: "1" }],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      {
        type: "goods",
        label: "商品",
        default: "T00",
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "brazilProduction",
        useStyle: true,
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "76,76026",
        options: [],
        components: "SelectInput",
        componentType: "ComRtData50",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000",
        options: [],
        components: "SelectInput",
        componentType: "ComPtData50",
        className: "w350",
        con: {},
      },
      {
        type: "transport",
        label: "运输方式",
        paramName: "transportIds",
        default: "T00",
        options: [],
        components: "SelectInput",
        componentType: "TransportSelect",
        className: "w350",
        con: {},
      },
    ],
    tableList: [
      { label: "时间", row: "time_id", width: "110", func: "" },
      { label: "流向中文名称", row: "trade_flow", width: "120", func: "" },
      { label: "主体中文名称", row: "reporter_ch", width: "140", func: "" },
      { label: "伙伴中文名称", row: "partner_ch", width: "140", func: "" },
      {
        label: "运输方式中文名称",
        row: "transport_name_cn",
        width: "140",
        func: "",
      },
      { label: "商品编码", row: "hs_id", width: "110", func: "" },
      { label: "商品名称", row: "hs_name", width: "140", func: "" },
      {
        label: "离岸价值",
        row: "metricfob_value",
        width: "140",
        func: "numFormat",
        align: "right",
      },
      {
        label: "保险费",
        row: "metricinsurance_value",
        width: "120",
        func: "numFormat",
        align: "right",
      },
      {
        label: "运费",
        row: "metricfreight_value",
        width: "120",
        func: "numFormat",
        align: "right",
      },
      {
        label: "到岸价值",
        row: "metriccif_value",
        width: "140",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "100",
        func: "numFormat",
        align: "right",
      },
      { label: "计量单位", row: "qty_unit", width: "100", func: "" },
      {
        label: "净重(kg)",
        row: "weight",
        width: "120",
        func: "numFormat",
        align: "right",
      },
      { label: "流向英文名称", row: "trade_flow_en", width: "120", func: "" },
      { label: "主体编码", row: "reporter_id", width: "100", func: "" },
      { label: "主体英文名称", row: "reporter_en", width: "140", func: "" },
      { label: "伙伴编码", row: "partner_id", width: "100", func: "" },
      { label: "伙伴英文名称", row: "partner_en", width: "140", func: "" },
      { label: "运输方式编码", row: "transport_id", width: "120", func: "" },
      {
        label: "运输方式英文名称",
        row: "transport_name",
        width: "140",
        func: "",
      },
    ],
  },
  巴西年度: {
    title: "巴西年度",
    viewsInstance: "brazil,annual",
    productId: [0],
    timeApi: "getBrazilTimeData",
    timeParam: "Y",
    tableApi: "getBrazilTableData",
    exportTableApi: "brazilTableDownload",
    needConcat: false,
    showOnlyOneChild: true,
    topControlList: [
      {
        type: "time",
        label: "时间",
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true,
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0",
        options: [
          { label: "进出口", value: "0" },
          { label: "进口", value: "2" },
          { label: "出口", value: "1" },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [{ label: "美元", value: "1" }],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      {
        type: "goods",
        label: "商品",
        default: "T00",
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "brazilProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "76",
        options: [],
        components: "SelectInput",
        componentType: "ComRtData50",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,156,036,533,275,728,381,392,352,156",
        options: [],
        components: "SelectInput",
        componentType: "ComPtData50",
        className: "w350",
        con: {},
      },
      {
        type: "transport",
        label: "运输方式",
        paramName: "transportIds",
        default: "T00",
        options: [],
        components: "SelectInput",
        componentType: "TransportSelect",
        className: "w350",
        con: {},
      },
    ],
    tableList: [
      { label: "时间", row: "time_id", width: "110", func: "" },
      { label: "流向中文名称", row: "trade_flow", width: "120", func: "" },
      { label: "主体中文名称", row: "reporter_ch", width: "140", func: "" },
      { label: "伙伴中文名称", row: "partner_ch", width: "140", func: "" },
      {
        label: "运输方式中文名称",
        row: "transport_name_cn",
        width: "140",
        func: "",
      },
      { label: "商品编码", row: "hs_id", width: "110", func: "" },
      { label: "商品名称", row: "hs_name", width: "140", func: "" },
      {
        label: "离岸价值",
        row: "metricfob_value",
        width: "140",
        func: "numFormat",
        align: "right",
      },
      {
        label: "保险费",
        row: "metricinsurance_value",
        width: "120",
        func: "numFormat",
        align: "right",
      },
      {
        label: "运费",
        row: "metricfreight_value",
        width: "120",
        func: "numFormat",
        align: "right",
      },
      {
        label: "到岸价值",
        row: "metriccif_value",
        width: "140",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "100",
        func: "numFormat",
        align: "right",
      },
      { label: "计量单位", row: "qty_unit", width: "100", func: "" },
      {
        label: "净重(kg)",
        row: "weight",
        width: "120",
        func: "numFormat",
        align: "right",
      },
      { label: "流向英文名称", row: "trade_flow_en", width: "120", func: "" },
      { label: "主体编码", row: "reporter_id", width: "100", func: "" },
      { label: "主体英文名称", row: "reporter_en", width: "140", func: "" },
      { label: "伙伴编码", row: "partner_id", width: "100", func: "" },
      { label: "伙伴英文名称", row: "partner_en", width: "140", func: "" },
      { label: "运输方式编码", row: "transport_id", width: "120", func: "" },
      {
        label: "运输方式英文名称",
        row: "transport_name",
        width: "140",
        func: "",
      },
    ],
  },
  // ===== 中国台湾 ===== （2026-07-13 新增；6 字段无运输方式；占位控件同中国澳门）
  台湾月度: {
    title: "中国台湾月度",
    viewsInstance: "taiwan,monthly",
    productId: [0],
    timeApi: "getTaiwanTimeData",
    timeParam: "M",
    tableApi: "getTaiwanTableData",
    exportTableApi: "taiwanTableDownload",
    needConcat: true,
    showOnlyOneChild: true,
    topControlList: [
      {
        type: "time",
        label: "时间",
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true,
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0",
        options: [
          { label: "进出口", value: "0" },
          { label: "进口", value: "2" },
          { label: "出口", value: "1" },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [{ label: "美元", value: "1" }],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      {
        type: "goods",
        label: "商品",
        default: "T00",
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "taiwanProduction",
        useStyle: true,
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "158",
        options: [],
        components: "SelectInput",
        componentType: "ComRtData60",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000",
        options: [],
        components: "SelectInput",
        componentType: "ComPtData60",
        className: "w350",
        con: {},
      },
    ],
    tableList: [
      { label: "时间", row: "time_id", width: "110", func: "" },
      { label: "流向中文名称", row: "trade_flow", width: "120", func: "" },
      { label: "主体中文名称", row: "reporter_ch", width: "140", func: "" },
      { label: "伙伴中文名称", row: "partner_ch", width: "140", func: "" },
      { label: "商品编码", row: "hs_id", width: "110", func: "" },
      { label: "商品名称", row: "hs_name", width: "140", func: "" },
      {
        label: "金额",
        row: "trade_value",
        width: "140",
        func: "numFormat",
        align: "right",
      },
      {
        label: "重量(kg)",
        row: "weight",
        width: "140",
        func: "numFormat",
        align: "right",
      },
      { label: "流向英文名称", row: "trade_flow_en", width: "120", func: "" },
      { label: "主体编码", row: "reporter_id", width: "100", func: "" },
      { label: "主体英文名称", row: "reporter_en", width: "140", func: "" },
      { label: "伙伴编码", row: "partner_id", width: "100", func: "" },
      { label: "伙伴英文名称", row: "partner_en", width: "140", func: "" },
    ],
  },
  台湾年度: {
    title: "中国台湾年度",
    viewsInstance: "taiwan,annual",
    productId: [0],
    timeApi: "getTaiwanTimeData",
    timeParam: "Y",
    tableApi: "getTaiwanTableData",
    exportTableApi: "taiwanTableDownload",
    needConcat: false,
    showOnlyOneChild: true,
    topControlList: [
      {
        type: "time",
        label: "时间",
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true,
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0",
        options: [
          { label: "进出口", value: "0" },
          { label: "进口", value: "2" },
          { label: "出口", value: "1" },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [{ label: "美元", value: "1" }],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      {
        type: "goods",
        label: "商品",
        default: "T00",
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "taiwanProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "158",
        options: [],
        components: "SelectInput",
        componentType: "ComRtData60",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,156,392,344,250,842,458,702,704,764",
        options: [],
        components: "SelectInput",
        componentType: "ComPtData60",
        className: "w350",
        con: {},
      },
    ],
    tableList: [
      { label: "时间", row: "time_id", width: "110", func: "" },
      { label: "流向中文名称", row: "trade_flow", width: "120", func: "" },
      { label: "主体中文名称", row: "reporter_ch", width: "140", func: "" },
      { label: "伙伴中文名称", row: "partner_ch", width: "140", func: "" },
      { label: "商品编码", row: "hs_id", width: "110", func: "" },
      { label: "商品名称", row: "hs_name", width: "140", func: "" },
      {
        label: "金额",
        row: "trade_value",
        width: "140",
        func: "numFormat",
        align: "right",
      },
      {
        label: "重量(kg)",
        row: "weight",
        width: "140",
        func: "numFormat",
        align: "right",
      },
      { label: "流向英文名称", row: "trade_flow_en", width: "120", func: "" },
      { label: "主体编码", row: "reporter_id", width: "100", func: "" },
      { label: "主体英文名称", row: "reporter_en", width: "140", func: "" },
      { label: "伙伴编码", row: "partner_id", width: "100", func: "" },
      { label: "伙伴英文名称", row: "partner_en", width: "140", func: "" },
    ],
  },
  阿根廷月度: {
    title: "阿根廷月度",
    timeApi: "getYears25", // 时间获取接口C
    viewsInstance: "argentina,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear25",
    exportTableApi: "worldTradeYear25",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "argentinaProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "032", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData25",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData25",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  阿根廷年度: {
    title: "阿根廷年度",
    timeApi: "getYears25", // 时间获取接口C
    viewsInstance: "argentina,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear25",
    exportTableApi: "worldTradeYear25",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "argentinaProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "032", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData25",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,076,152,156,276,376,380,528,724,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData25",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  中国月度: {
    title: "中国月度",
    showOnlyOneChild: true,
    productId: [0],
    viewsInstance: "china,monthly", // 对应的组件地址
    timeApi: "getYears", // 时间获取接口C
    timeParam: "C", // 调用方法时使用的参数
    tableApi: "chinaTradeMonth",
    exportTableApi: "exportChinaTradeMonth",
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        controlDimension: "hsId",
        components: "china-month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "3", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "3",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "0",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "moneyItype",
        default: "2",
        options: [
          {
            label: "美元",
            value: "2",
          },
          {
            label: "人民币",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "100000", // 默认商品
        options: [],
        paramName: "hsId",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "HaiGuanGoods",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "regionId",
        default: "0", // 默认主体
        options: [],
        // showSelect: config.showSelect || false,   //控制主体是否能选择
        showSelect: true,
        components: "SelectInput",
        componentType: "HaiGuanRegion",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "stateId",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "HaiGuanState",
        className: "w350",
        con: {},
      },
      {
        type: "way",
        label: "方式",
        paramName: "trademodeId",
        default: "0", // 默认方式
        options: [],
        components: "SelectInput",
        componentType: "Trademode",
        className: "w320",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "dateTime",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "ioreName",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "regionName",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "stateName",
        width: "160",
        func: "",
      },
      {
        label: "方式中文名称",
        row: "trademodeName",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hsId",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hsName",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "moneyAmount",
        width: "160",
        func: "numFormat",
        formatter: "formatColAmount",
        align: "right",
      },
      {
        label: "第一数量",
        row: "amount",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第一计量单位",
        row: "hsUnitsName",
        width: "160",
        func: "",
      },
      {
        label: "第二数量",
        row: "secondAmount",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第二计量单位",
        row: "hsUnitsNameTwo",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "regionId",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "stateId",
        width: "160",
        func: "",
      },
      {
        label: "方式编码",
        row: "trademodeId",
        width: "160",
        func: "",
      },
    ],
  },
  韩国月度: {
    title: "韩国月度",
    timeApi: "getYears7", // 时间获取接口C
    viewsInstance: "korea,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear7",
    exportTableApi: "worldTradeYear7",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "千美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "koreaProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "410", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData7",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData7",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  韩国年度: {
    title: "韩国年度",
    timeApi: "getYears7", // 时间获取接口C
    viewsInstance: "korea,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear7",
    exportTableApi: "worldTradeYear7",
    productId: [0],
    timeParam: "Y", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Year",
        timeParamList: ["startTime", "endTime"],
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "千美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "koreaProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "410", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData7",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData7",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "160",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },

  中国澳门月度: {
    title: "中国澳门月度",
    timeApi: "getYears22", // 时间获取接口C
    viewsInstance: "chinaMacao,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear22",
    exportTableApi: "worldTradeYear22",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        className: "w600",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
          {
            label: "再出口",
            value: "3",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "转运",
            value: "8",
          },
          {
            label: "暂时出口",
            value: "9",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "澳门元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "chinaMacaoProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "446", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData22",
        className: "w600",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "156", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData22",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  中国澳门年度: {
    title: "中国澳门年度",
    timeApi: "getYears22", // 时间获取接口C
    viewsInstance: "chinaMacao,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear22",
    exportTableApi: "worldTradeYear22",
    productId: [0],
    timeParam: "Y", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Year",
        timeParamList: ["startTime", "endTime"],
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        className: "w600",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
          {
            label: "再出口",
            value: "3",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "转运",
            value: "8",
          },
          {
            label: "暂时出口",
            value: "9",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "澳门元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "chinaMacaoProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "446", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData22",
        className: "w600",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "156,124,392,842,410,250,276,764,702,554,356", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData22",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  中国香港月度: {
    title: "中国香港月度",
    timeApi: "getYears23", // 时间获取接口C
    viewsInstance: "chinaHK,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear23",
    exportTableApi: "worldTradeYear23",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "本地出口",
            value: "5",
          },
          {
            label: "转口",
            value: "7",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "千港元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "chinaHKProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "344", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData23",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData23",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },

      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  中国香港年度: {
    title: "中国香港年度",
    timeApi: "getYears23", // 时间获取接口C
    viewsInstance: "chinaHK,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear23",
    exportTableApi: "worldTradeYear23",
    productId: [0],
    timeParam: "Y", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Year",
        timeParamList: ["startTime", "endTime"],
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "本地出口",
            value: "5",
          },
          {
            label: "转口",
            value: "7",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "千港元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "chinaHKProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "344", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData23",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,156,124,392,842,410,250,276,702,608,458,702", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData23",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },

      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  印尼月度: {
    title: "印尼月度",
    timeApi: "getYears3", // 时间获取接口C
    viewsInstance: "indonesia,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear3",
    exportTableApi: "worldTradeYear3",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        className: "w350",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "indonesiaProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "360", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData3",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData3",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "港口",
        paramName: "portIds",
        default: "IDN000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "port",
        className: "w350",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "港口中文名称",
        row: "port_name_cn",
        width: "160",
        func: "numFormat",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重（kg）",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "110",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
      {
        label: "港口编码",
        row: "port_id",
        width: "110",
        func: "numFormat",
      },
      {
        label: "港口英文名称",
        row: "port_name_en",
        width: "160",
        func: "numFormat",
      },
    ],
  },
  印尼年度: {
    title: "印尼年度",
    timeApi: "getYears3", // 时间获取接口C
    viewsInstance: "indonesia,annual", // 对应的组件地址
    needConcat: false,
    tableApi: "getWorldTradeYear3",
    exportTableApi: "worldTradeYear3",
    productId: [0],
    timeParam: "Y", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Year",
        timeParamList: ["startTime", "endTime"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        className: "w350",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "indonesiaProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "360", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData3",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData3",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "港口",
        paramName: "portIds",
        default: "IDN000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "port",
        className: "w350",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "港口中文名称",
        row: "port_name_cn",
        width: "160",
        func: "numFormat",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重（kg）",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
      {
        label: "港口编码",
        row: "port_id",
        width: "160",
        func: "numFormat",
      },
      {
        label: "港口英文名称",
        row: "port_name_en",
        width: "160",
        func: "numFormat",
      },
    ],
  },
  菲律宾月度2023: {
    title: "菲律宾月度（-2023）",
    timeApi: "getYears5", // 时间获取接口C
    viewsInstance: "philippines,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear5",
    exportTableApi: "worldTradeYear5",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "philippinesProduction2023",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "608", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData5",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData5",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  菲律宾月度2024: {
    title: "菲律宾月度（2024-）",
    timeApi: "getYears5", // 时间获取接口C
    viewsInstance: "philippines,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear5",
    exportTableApi: "worldTradeYear5",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "philippinesProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "608", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData5",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData5",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  菲律宾年度2023: {
    title: "菲律宾年度（-2023）",
    timeApi: "getYears3", // 时间获取接口C
    viewsInstance: "philippines,annual", // 对应的组件地址
    needConcat: false,
    tableApi: "getWorldTradeYear5",
    exportTableApi: "worldTradeYear5",
    productId: [0],
    timeParam: "Y", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Year",
        timeParamList: ["startTime", "endTime"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "philippinesProduction2023",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "608", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData5",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData5",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  菲律宾年度2024: {
    title: "菲律宾年度（2024-）",
    timeApi: "getYears3", // 时间获取接口C
    viewsInstance: "philippines,annual", // 对应的组件地址
    needConcat: false,
    tableApi: "getWorldTradeYear5",
    exportTableApi: "worldTradeYear5",
    productId: [0],
    timeParam: "Y", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Year",
        timeParamList: ["startTime", "endTime"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "philippinesProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "608", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData5",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData5",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  泰国月度: {
    title: "泰国月度",
    timeApi: "getYears4", // 时间获取接口C
    viewsInstance: "thailand,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear4",
    exportTableApi: "worldTradeYear4",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "泰铢",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "thailandProduction",
        useStyle: true,
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "764", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData4",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData4",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  泰国年度: {
    title: "泰国年度",
    timeApi: "getYears4", // 时间获取接口C
    viewsInstance: "thailand,annual", // 对应的组件地址
    needConcat: false,
    tableApi: "getWorldTradeYear4",
    exportTableApi: "worldTradeYear4",
    productId: [0],
    timeParam: "Y", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Year",
        timeParamList: ["startTime", "endTime"],
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "泰铢",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "thailandProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "764", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData4",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData4",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
    ],
  },
  法国月度: {
    title: "法国月度",
    timeApi: "getYears26", // 时间获取接口C
    viewsInstance: "france,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear26",
    exportTableApi: "worldTradeYear26",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "欧元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "franceProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "250", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData26",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData26",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  法国年度: {
    title: "法国年度",
    timeApi: "getYears26", // 时间获取接口C
    viewsInstance: "france,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear26",
    exportTableApi: "worldTradeYear26",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "欧元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "franceProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "250", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData26",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,040,056,156,276,380,528,724,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData26",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  南非月度: {
    title: "南非月度",
    timeApi: "getYears27", // 时间获取接口C
    viewsInstance: "southAfrica,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear27",
    exportTableApi: "worldTradeYear27",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        className: "w350",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "南非兰特",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "sounthAfricaProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "710,710001", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData27",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData27",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "运输",
        paramName: "transportIds",
        default: "T00", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "sports",
        className: "w350",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "运输方式名称",
        row: "transport_name_cn",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "",
        align: "right",
      },

      {
        label: "计量单位",
        row: "qty_unit",
        width: "110",
        func: "",
      },

      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
      {
        label: "运输方式编码",
        row: "transport_id",
        width: "160",
        func: "",
      },
      {
        label: "运输方式英文名称",
        row: "transport_name",
        width: "160",
        func: "",
      },
    ],
  },
  南非年度: {
    title: "南非年度",
    timeApi: "getYears27", // 时间获取接口C
    viewsInstance: "southAfrica,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear27",
    exportTableApi: "worldTradeYear27",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        className: "w350",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "南非兰特",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "sounthAfricaProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "710,710001", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData27",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,032,076,156,276,356,364,528,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData27",
        className: "w350",
        con: {},
      },
      {
        type: "partner",
        label: "运输",
        paramName: "transportIds",
        default: "T00", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "sports",
        className: "w350",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "运输方式名称",
        row: "transport_name_cn",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "",
        align: "right",
      },

      {
        label: "计量单位",
        row: "qty_unit",
        width: "110",
        func: "",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
      {
        label: "运输方式编码",
        row: "transport_id",
        width: "160",
        func: "",
      },
      {
        label: "运输方式英文名称",
        row: "transport_name",
        width: "160",
        func: "",
      },
    ],
  },

  美国本地出口月度: {
    title: "美国本地出口月度",
    timeApi: "getYears28", // 时间获取接口C
    viewsInstance: "USA,monthbdck", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear28",
    exportTableApi: "worldTradeYear28",
    timeParam: "M", // 调用方法时使用的参数
    timeFlowId: "5",
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "5", // 默认进出口
        options: [
          {
            label: "本地出口",
            value: "5",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        flowId: "5",
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "USAProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "842,8420101", // 默认主体
        options: [],
        flowId: "5",
        components: "SelectInput",
        componentType: "ComRtData28",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        flowId: "5",
        components: "SelectInput",
        componentType: "ComPtData28",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },

      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第一数量",
        row: "quantity1",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第一计量单位",
        row: "qty_unit1",
        width: "110",
        func: "",
      },
      {
        label: "第二数量",
        row: "quantity2",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第二计量单位",
        row: "qty_unit2",
        width: "110",
        func: "",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  美国总出口月度: {
    title: "美国总出口月度",
    timeApi: "getYears28", // 时间获取接口C
    viewsInstance: "USA,monthzck", // 对应的组件地址
    tableApi: "getWorldTradeYear28",
    exportTableApi: "worldTradeYear28",
    needConcat: true,
    timeParam: "M", // 调用方法时使用的参数
    timeFlowId: "6",
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",

        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "6", // 默认进出口
        options: [
          {
            label: "总出口",
            value: "6",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        flowId: "6",
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "USAProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "842,8420101", // 默认主体
        options: [],
        flowId: "6",
        components: "SelectInput",
        componentType: "ComRtData28",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        flowId: "6",
        components: "SelectInput",
        componentType: "ComPtData28",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },

      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第一数量",
        row: "quantity1",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第一计量单位",
        row: "qty_unit1",
        width: "110",
        func: "",
      },
      {
        label: "第二数量",
        row: "quantity2",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第二计量单位",
        row: "qty_unit2",
        width: "110",
        func: "",
      },

      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },

  美国消费进口月度: {
    title: "美国消费进口月度",
    timeApi: "getYears28", // 时间获取接口C
    viewsInstance: "USA,monthxfjk", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear28",
    exportTableApi: "worldTradeYear28",
    timeFlowId: "11",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "11", // 默认进出口
        options: [
          {
            label: "消费进口",
            value: "11",
          },
        ],
        components: "SelectRadio",
        className: "w440",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        className: "w350",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        flowId: "11",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "USAProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "842,8420101", // 默认主体
        options: [],
        flowId: "11",
        components: "SelectInput",
        componentType: "ComRtData28",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        flowId: "11",
        components: "SelectInput",
        componentType: "ComPtData28",
        className: "w350",
        con: {},
      },
      // {
      //   type: "rtates",
      //   label: "关税",
      //   paramName: "rateIds",
      //   default: "T00", // 默认伙伴
      //   flowId: "11",
      //   options: [],
      //   components: "SelectInput",
      //   componentType: "rtates",
      //   className: "w350",
      //   con: {},
      // },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "海关价值",
        row: "customs_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "到岸价进口价值",
        row: "import_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "完税后交货价值",
        row: "duty_paid_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "应税价值",
        row: "dutiable_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "应计关税",
        row: "duties_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "进口税费",
        row: "insurance_freight_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第一数量",
        row: "quantity1",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第一计量单位",
        row: "qty_unit1",
        width: "110",
        func: "",
      },
      {
        label: "第二数量",
        row: "quantity2",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第二计量单位",
        row: "qty_unit2",
        width: "110",
        func: "",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  美国一般进口月度: {
    title: "美国一般进口月度",
    timeApi: "getYears28", // 时间获取接口C
    viewsInstance: "USA,monthybjk", // 对应的组件地址
    tableApi: "getWorldTradeYear28",
    needConcat: true,
    exportTableApi: "worldTradeYear28",
    timeParam: "M", // 调用方法时使用的参数
    timeFlowId: "10",
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "10", // 默认进出口
        options: [
          {
            label: "一般进口",
            value: "10",
          },
        ],
        components: "SelectRadio",
        className: "w440",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        flowId: "10",
        componentType: "USAProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "842,8420101", // 默认主体
        options: [],
        flowId: "10",
        components: "SelectInput",
        componentType: "ComRtData28",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        flowId: "10",
        components: "SelectInput",
        componentType: "ComPtData28",
        className: "w350",
        con: {},
      },
      // {
      //   type: "rtates",
      //   label: "关税",
      //   paramName: "rateIds",
      //   default: "T00", // 默认伙伴
      //   flowId: "10",
      //   options: [],
      //   components: "SelectInput",
      //   componentType: "rtates",
      //   className: "w350",
      //   con: {},
      // },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "到岸进口额",
        row: "cif_imports_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "完税价格",
        row: "customs_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "进口费用",
        row: "import_charges_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第一数量",
        row: "quantity1",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第一计量单位",
        row: "qty_unit1",
        width: "110",
        func: "",
      },
      {
        label: "第二数量",
        row: "quantity2",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第二计量单位",
        row: "qty_unit2",
        width: "110",
        func: "",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
};
export { baseRef };
